import React from 'react'
import { Button, Popconfirm, useNotification } from '@fortressiq/fiq-ds'
import api from 'lib/Api'

const IpDisableButton = ({ rowData, handleReFetch }) => {
  const { addNotification } = useNotification()

  const handleDisable = async record => {
    try {
      const { data } = await api.put(`/ip_addresses/${record.id}`, { ip_address: { active: false } })
      if (!data.active) {
        handleReFetch()
      }
    } catch (error) {
      addNotification({
        description: error.message || 'An error occurred',
        message: 'Error',
        type: 'error',
      })
    }
  }
  return (
    <Popconfirm
      cancelText='No'
      closeOnOutsideClick={true}
      okText='Yes'
      okType='danger'
      onConfirm={() => handleDisable(rowData)}
      title={
        <div style={{ width: '350px' }}>
          <p style={{ marginBottom: '0px' }}>Are you sure you want to disable this IP address? </p>
          <p style={{ marginTop: '0px', marginBottom: '5px' }}>Note: It will be permanently disabled.</p>
        </div>
      }
      className='disableIpAddress'
    >
      <Button type='danger' size='small' disabled={!rowData.active}>
        {!rowData.active && rowData.verified ? 'Disabled' : 'Disable'}
      </Button>
    </Popconfirm>
  )
}

export default IpDisableButton
